import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { decimalSeparator, formatCashAmount, formatChipAmount } from "@/lib/formatting";

interface AddPlayerRowProps {
  pendingPlayerName: string;
  setPendingPlayerName: (name: string) => void;
  commitPendingPlayer: () => void;
  currencySymbol: string;
  suggestedCashIn: number;
  suggestedChipsBought: number;
}

export function AddPlayerRow({
  pendingPlayerName,
  setPendingPlayerName,
  commitPendingPlayer,
  currencySymbol,
  suggestedCashIn,
  suggestedChipsBought,
}: AddPlayerRowProps) {
  return (
    <div className="grid gap-2 grid-cols-[1.75rem_minmax(0,1fr)_5.25rem_5.25rem] md:grid-cols-[1.75rem_2fr_1fr_1fr] md:gap-3 items-center opacity-60">
      <span className="size-8" aria-hidden="true" />

      <Label htmlFor="pending-player-name" className="sr-only">
        Add player name
      </Label>
      <Input
        id="pending-player-name"
        value={pendingPlayerName}
        onChange={(e) => setPendingPlayerName(e.target.value)}
        onBlur={commitPendingPlayer}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            commitPendingPlayer();
          }
        }}
        placeholder="Add player..."
        className="bg-muted/40 h-8 px-2 text-xs md:h-9 md:px-3 md:text-sm"
      />

      <div className="relative">
        <span className="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 text-muted-foreground text-xs md:left-3 md:text-sm">
          {currencySymbol}
        </span>
        <Input
          value={formatCashAmount(suggestedCashIn)}
          readOnly
          className="bg-muted/40 pl-4 pr-2 h-8 text-xs md:pl-7 md:pr-3 md:h-9 md:text-sm"
          aria-label="Suggested cash-in"
        />
      </div>
      <Input
        value={formatChipAmount(suggestedChipsBought)}
        readOnly
        className="bg-muted/40 h-8 px-2 text-xs md:h-9 md:px-3 md:text-sm"
        aria-label="Suggested chips bought"
      />
    </div>
  );
}
